import { Navigate, useParams } from "react-router";
import useClientContext from "../../../context/useClientContext";
import { pageRoutes } from "../../../routes";
import ObjectDetailsPage from "../../entityFields/ObjectDetailsPage";
import InvoiceDetailsPage from "../expense-management/invoices/InvoiceDetailsPage";

const ApprovalObjectPage = () => {
  const { type, id } = useParams();
  const { clientCode } = useClientContext();

  if (!type || !id) {
    return <Navigate to=".." />;
  }

  const backButtonPath = `/${clientCode}/${pageRoutes.workflows}/${pageRoutes.approvals}`;

  if (type === "Invoice") {
    return <InvoiceDetailsPage forApproval backButtonPath={backButtonPath} />;
  }

  return <ObjectDetailsPage forApproval objectId={id} objectType={type} backButtonPath={backButtonPath} />;
};

export default ApprovalObjectPage;
